// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10b45d0c","833":"9789248a"}[chunkId] + ".chunk.js";
};